import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Layout } from "@/components/Layout";
import { RulesManager } from "@/components/buildRule/RulesManager";
import { RulesVersion } from "@/components/VersionRule/RulesVersion";
import { RuleVersionHistory } from "@/components/VersionRule/RuleVersionHistory";
import { SearchResolve } from "@/components/SearchResolve";
import { DataQuality } from "@/components/DataQuality";
import { ImportExport } from "@/components/ImportExport";
import { AuditLog } from "@/components/AuditLog";
import { AIConsole } from "@/components/AIConsole";
import { Settings } from "@/components/Settings";
import NotFound from "@/pages/not-found";
import EdiTableRuleBuilder from "./components/buildRule/CreateRule";
import ModifyValue from "./components/VersionRule/ModifyValue";
import { RulesFunction } from "./components/FunctionRule/RulesFunction";
import { CreatePublishRule } from "./components/PublishRule/CreatePublishRule";
import CreateRulePrompt from "./components/AIBuilder/CreateRulePrompt";


function Router() {
  return (
    <Layout>
      <Switch>
        <Route path="/" component={RulesManager} />
        <Route path="/rulefunction" component={RulesFunction} />
        <Route path="/ruleversion" component={RulesVersion} />
        <Route path="/rulepublish" component={CreatePublishRule} />
        <Route path="ruleversion/:ruleId" component={RuleVersionHistory} />
        <Route path="/rules/edit/:ruleId" component={EdiTableRuleBuilder} />
        <Route path="/version/edit/:ruleId" component={ModifyValue} />
        <Route path="/search" component={SearchResolve} />
        <Route path="/quality" component={DataQuality} />
        <Route path="/import" component={ImportExport} />
        <Route path="/audit" component={AuditLog} />
        <Route path="/ai-builder" component={CreateRulePrompt} />
        <Route path="/ai" component={AIConsole} />
        <Route path="/settings" component={Settings} />
        <Route component={NotFound} />
      </Switch>
    </Layout>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Router />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
